import Repository from "./Repository";

const resource = "/users";

export default {
	signup(payload) {
		return Repository.post(`${resource}`, payload);
	}
}